import { render } from "./Logout.vue?vue&type=template&id=41d864fe&scoped=true&ts=true"
import script from "./Logout.vue?vue&type=script&lang=ts"
export * from "./Logout.vue?vue&type=script&lang=ts"

import "./Logout.vue?vue&type=style&index=0&id=41d864fe&lang=less&scoped=true"

import exportComponent from "/Users/yzh-mac/Documents/inm/git/砺成文化/word-admin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d864fe"]])

export default __exports__